module.exports = __webpack_public_path__ + "assets/img/37_1459_big.30688165.jpg";